<template>
    <div id="listCharge">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                 <div class="page-name">
                     <div class="page-title"> Charge List</div>
                    <router-link v-if="canAdd" class="btn btn-primary pull-right" v-bind:to="{name: 'ChargeCreate'}" >
                        <i class="fp-add"> </i>  Add
                    </router-link>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content charge-list">
                        <data-table-filter-config :moduleName="'chargeList'" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <section class="data-table bg-white">
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'chargeList'" :position="'top'">
                                </custom-pagination>

                                <vue-good-table
                                        ref="listChargesTable"
                                        mode="remote"
                                        @on-page-change="onPageChange"
                                        @on-sort-change="onSortChange"
                                        @on-column-filter="onColumnFilter"
                                        @on-per-page-change="onPerPageChange"
                                        :totalRows="totalRecords"
                                        title="Charges"
                                        :columns="userColumns"
                                        :rows="rows"
                                        :paginate="true"

                                        :paginationOptions="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"
                                        :sort-options="{
                                    enabled: true,
                                    }">
                                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                        <div :key="key">
                                            <div v-if="props.column.field == 'action'">
                                                <template v-if="canUpdate">
                                                    <router-link class="fp-edit" v-bind:to="{name: 'ChargeEdit',params:{id:props.row.id}}" title="Update Charge">
                                                    </router-link>
                                                </template>
                                                <a v-if="!hidden">|</a>
                                                <a href="javascript:void(0)" class="fp-remove" v-on:click="deleteCharge(props.row.id,key)" v-if="!hidden" title="Remove Charge"></a>
                                            </div>
                                            <div v-else>
                                                {{props.formattedRow[props.column.field]}}
                                            </div>
                                        </div>
                                    </template>
                                </vue-good-table>
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                                </custom-pagination>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>

<script>


    import Vue from 'vue';

    
    



    import {commonMixins} from '../../mixins/commonMixins';
    import {dataTableMixins} from '../../mixins/dataTableMixins';

    export default {
        name: "listCharge",
        metaInfo() {
            return {title: "Charge List | " +process.env.COPYRIGHT_NAME}
        },
        mixins:[commonMixins,dataTableMixins],
        data: () => ({

            firstLoad : 0,
            userColumns:[],
            columns: [
                {
                    label: 'Actions',
                    field: 'action',
                    html: true,
                    hidden:false,
                    sortable: false,
                },
                {
                    label: 'Charge Identifier',
                    field: 'charge_identifier',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Charge Identifier", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Charge Name',
                    field: 'charge_name',
                    hidden:false,
                    filterable: true,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Charge Name", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Charge Type',
                    field: 'charge_type',
                    hidden:false,
                    fpFieldType:"option",
                    filterable: true,
                    html: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Charge Type", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: ['Day','Week','Month','Mile','Fixed'],// dropdown (with selected values) instead of text input
                        // filterFn: this.onColumnFilter, //custom filter function that
                        // trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Rate',
                    field: 'rate',
                    type:'number',
                    fpFieldType:"integer",
                    hidden:false,
                    filterable: true,
                    html: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Rate", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                // {
                //     label: 'Date',
                //     field: 'updated_at',
                //     html: false,
                //     filterOptions: {
                //         enabled: true, // enable filter for this column
                //         placeholder: "Filter", // placeholder for filter input
                //         filterValue: '', // initial populated value for this filter
                //         filterDropdownItems: [], // dropdown (with selected values) instead of text input
                //         filterFn: this.onColumnFilter, //custom filter function that
                //         trigger: "enter" //only trigger on enter not on keyup
                //     }
                // },

            ],
            rows: [],
            totalRecords: 0,
            permissions:[],
            loading:false,
            hidden:true,
            cantAccessPage:"",
            canAdd:false,
            canUpdate:false,
        }),
        watch:{
            permissions: function(permission){
                var self = this;
                permission.forEach(function (permissions) {
                    if(permissions.name == 'list_charges') {
                        self.cantAccessPage = true;
                    }
                    if(permissions.name == 'add_charges') {
                        self.canAdd = true;
                        self.canUpdate = true;
                    }
                });
                if(self.cantAccess == ''){
                    self.cantAccess = false;
                }
            }
        },
        created: function() {
            this.serverParams.sort = {field:"updated_at",type:"desc"};
        },
        mounted: function () {

            this.getPermissions();

        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.listChargesTable.unselectAllInternal();
            },

            //
            editCharge(params) {

                var self = this;
                self.$router.push("/addcharge/" + params.row.id);
            },

            /*onColumnFilter(params) {
                this.updateParams(params);
                { field: ('charge_identifier');
                    field: ('charge_name'); field: ('charge_type');
                    field: ('rate');field: ('updated_at');}
                this.serverParams.page = 1 ;
                var filtersPr = JSON.parse(JSON.stringify(this.serverParams));
                var filters = filtersPr.columnFilters;

                if (this.firstLoad == 1 || filters.charge_identifier || filters.charge_name || filters.charge_type || filters.rate || filters.updated_at ) {

                    this.loadList();
                }


            },
            updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
                console.log(this.serverParams.columnFilters.company);
            },
            onPageChange(params) {
                this.updateParams({page: params.currentPage});

                this.loadList();
            },
            onSortChange(params) {
                this.updateParams({
                    sort: {
                        type: params[0].type,
                        field: params[0].field,
                    },

                });
                this.loadList();
            },
            //
            onPerPageChange(params) {
                this.updateParams({perPage: params.currentPerPage});
                this.serverParams.page = 1 ;
                this.totalRecords = self.totalRecords;
                this.loadList();
            },*/

            loadList: function(){

                var self = this;
                self.loading = true;
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/list_charge",
                    type: "GET",
                    crossDomain: true,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    data:{
                        page: self.serverParams.page,
                        perPage: self.serverParams.perPage,
                        filters: this.serverParams.columnFilters,
                        sort: this.serverParams.sort,
                    },
                    success: function (data) {
                        self.loading = false;
                        //console.log(data.content[0]["id"]);
                        if (data.status == "success") {
                            self.rows = data.content.row;

                            self.perPage = data.content.perPage;
                            // if (data.content.totalRecords == 0){
                            //     self.rows = 0;
                            // }
                            self.totalRecords = data.content.totalRecords;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'list-charge-data')

                    }
                });
            },
            deleteCharge:function(id,index){
                var self = this;
                console.log(id);

                if(confirm("Are You Sure You Want To Delete This Charge?")){
                    $.ajax({
                        url: process.env.API + "/" + process.env.VERSION + "/remove_charge",
                        type: "POST",
                        data: 'id='+id,
                        headers: this.ajxHeaders,
                        dataType: 'json',
                        success: function (data) {
                            if (data.code == 200) {
                                console.log(data.message);
                                self.loadList();
                                self.rows = data.content.row;
                                self.totalRecords = data.content.totalRecords;

                            }
                        },
                        error: function (jqXHR, exception) {
                            self.generateStatusCodeMessage(jqXHR,false,'delete-charge-data')
                        }

                    });

                }
            }
        }
    };
</script>




// WEBPACK FOOTER //
// src/components/charge/ChargeList.vue